import React from 'react'
import useStore from 'state/knovStore'
import styles from './twitterMediaAlert.module.scss'

export default function TwitterMediaAlert({ modalParams, closeModal }) {
    const openEditProfileModal = useStore(state => state.actions.modalActions.openEditProfileModal)
    const primaryButtonText = modalParams?.primaryButtonText || 'Go to Settings'
    const secondaryButtonText = modalParams?.secondaryButtonText
    const secondaryButtonAction = modalParams?.secondaryButtonAction || closeModal

    return (
        <div className={styles.twitterMediaAlertComp}>
            <div className={styles.iconContainer}>
                <i className="fa fa-info-circle" />
            </div>
            <div className={styles.messageContainer}>
                <div className={styles.messageTitle}>Media Posting Unavailable</div>
                <br />
                <br />
                Your Twitter/X connection was created before we added support for posting images and
                videos. To enable media posting to Twitter/X, please disconnect and reconnect your
                Twitter/X account.
            </div>
            <div className={styles.instructionsContainer}>
                <div className={styles.instructionsTitle}>How to fix:</div>
                <br />
                1. Use the "Disconnect" button to disconnect Twitter/X
                <br />
                2. Use the "Connect Twitter/X Account" button to reconnect
            </div>
            <div className={styles.actions}>
                <button
                    onClick={openEditProfileModal}
                    className={`${styles.button} ${styles.primaryButton}`}
                >
                    {primaryButtonText}
                </button>
                {secondaryButtonText && (
                    <button
                        onClick={secondaryButtonAction}
                        className={`${styles.button} ${styles.secondaryButton}`}
                    >
                        {secondaryButtonText}
                    </button>
                )}
            </div>
        </div>
    )
}
